<template>
  <div class="outer-container">
    <div class="container">
      <div class="row">
        <div class="col-6  left-heading">
          <img
            src="../../assets/im/lg_full_color_IM_4x.png"
            alt=""
            class="logo-im"
          />
          <h2>
            A coding course <br />
            that
            <span class="stroke-pink"></span>
          </h2>
          <h5>
            Train remotely to become a Machine Learning engineer & <br />
            pay no tuition until you start getting PAID.<br /><br />
            Deadline for this Course has ended.<br />
            keep an eye out on our website and social media pages for future ISA
            Programs.
          </h5>

          <a href="#im" class="btn">
            Apply Now
          </a>
          <h6>
            Deadline 30th April, 2021
          </h6>
          <div class=" right-image-social">
            <div class="flex">
              <a href="https://www.facebook.com/upskillbd/" target="_blank">
                <img
                  class="left"
                  src="../../assets/chaldal/Icon awesome-facebook-f.svg"
                  alt=""
                />
              </a>
              <a
                href="https://www.linkedin.com/company/upskillbd/"
                target="_blank"
              >
                <img
                  src="../../assets/chaldal/Icon awesome-linkedin-in.svg"
                  alt=""
                />
              </a>
            </div>
          </div>
        </div>

        <div class="col-6  right-image">
          <img src="../../assets/im/bouy.png" alt="" />
        </div>
      </div>
    </div>
    <div
      class="container banner-bottom border-bottom "
      style="background-color:#FF165D; border-radius:10px;"
    >
      <h2>
        How will it pay you?
      </h2>
      <div class="grid">
        <div class="flexing">
          <h4>1</h4>
          <h3>
            Complete The Course
          </h3>
        </div>

        <div class="flexing">
          <h4>2</h4>
          <h3>
            Get Certified
          </h3>
        </div>

        <div class="flexing">
          <h4>3</h4>
          <h3>
            Complete The Assigned Project
          </h3>
        </div>

        <div class="flexing">
          <h4>4</h4>
          <h3>
            Proceed To Interview
          </h3>
        </div>

        <div class="flexing">
          <h4>5</h4>
          <h3>
            Get Hired!
          </h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>
<style scoped>
/* .stroke-pink {
  background-image: linear-gradient(#1e96fc, #1e96fc);
  background-position: 0 82%;
  background-size: 100% 18px;
  background-repeat: no-repeat;
} */

.container {
  max-width: 1300px !important;
}
.outer-container {
  background: #f5f9fc;
  opacity: 1;
}
.left-heading {
  padding-top: 65px;
  display: flex;

  flex-direction: column;
  justify-content: flex-end;
  max-height: 750px;
}

.left-heading span::before {
  padding-left: 15px;
  position: absolute;
  content: "PAYS YOU";
  animation-name: animate;
  animation-duration: 6s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;

  -webkit-animation-name: animate;
  -webkit-animation-duration: 6s;
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-timing-function: linear;
}
.btn {
  background-color: slategray !important;
}
@keyframes animate {
  0% {
    content: "HIRES YOU";
  }
  20% {
    content: "EMPOWERS YOU";
  }
  40% {
    content: "ACCREDITS YOU";
  }
  60% {
    content: "PAYS YOU";
  }
  80% {
    content: "CERTIFIES YOU";
  }
  100% {
    content: "REWARDS YOU";
  }
}

@-o-keyframes animate {
  0% {
    content: "HIRES YOU";
  }
  20% {
    content: "EMPOWERS YOU";
  }
  40% {
    content: "ACCREDITS YOU";
  }
  60% {
    content: "PAYS YOU";
  }
  80% {
    content: "CERTIFIES YOU";
  }
  100% {
    content: "REWARDS YOU";
  }
}

@-moz-keyframes animate {
  0% {
    content: "HIRES YOU";
  }
  20% {
    content: "EMPOWERS YOU";
  }
  40% {
    content: "ACCREDITS YOU";
  }
  60% {
    content: "PAYS YOU";
  }
  80% {
    content: "CERTIFIES YOU";
  }
  100% {
    content: "REWARDS YOU";
  }
}
@-webkit-keyframes animate {
  0% {
    content: "HIRES YOU";
  }
  20% {
    content: "EMPOWERS YOU";
  }
  40% {
    content: "ACCREDITS YOU";
  }
  60% {
    content: "PAYS YOU";
  }
  80% {
    content: "CERTIFIES YOU";
  }
  100% {
    content: "REWARDS YOU";
  }
}

.left-heading h2 {
  text-transform: uppercase;
  font-family: "Open Sans";
  font-size: 60px;
  font-weight: 800;
  letter-spacing: -3.6px;
  line-height: 70px;
  color: #3c4663;
  padding-top: 10px;
}
.left-heading h6 {
  font-family: "Open Sans";

  font-size: 18px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 24px;
  color: #3c4663;
}
.left-heading h5 {
  font-family: "Open Sans";
  font-size: 18px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 24px;
  color: #84888b;
  padding-top: 20px;
  padding-bottom: 45px;
}
.left-heading h2 span {
  text-transform: uppercase;
  font-family: "Open Sans";

  font-size: 60px;
  font-weight: 800;
  letter-spacing: -3.6px;
  line-height: 70px;
  color: #ff165d;
}
.left-heading h6 {
  padding-top: 36px;
  padding-bottom: 0;
  letter-spacing: 0px;
  color: #ff165d;
  font-family: "Open Sans";
  font-size: 18px;
  font-weight: 600;
}
.right-image {
  max-height: 750px;
  display: flex;
  align-items: flex-end;
  flex-direction: column;
}
.right-image img {
  padding-top: 50px;

  max-height: 638px;
  display: flex;
  align-items: flex-end;
}
.right-image-social {
  display: flex;

  align-items: flex-end;
  padding-bottom: 25px;
  padding-top: 45px;
}
.right-image-social img {
  color: #ff165d !important;
}
.btn {
  background-color: #035bf4;
  text-align: center;
  max-width: 300px;
  height: 60px;
  color: white;
  box-shadow: 0px 5px 10px #035bf41a;
  border-radius: 35px;
  padding-top: 20px;
}
a {
  text-transform: capitalize;
  font-family: "Open Sans";
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 0px;
  line-height: 24px;
  color: #181c2d;
}
.banner-bottom {
  padding-top: 54px;
  padding-bottom: 50px;
  padding-left: 50px;
  padding-right: 50px;
}
.flexing {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px 10px;
}
.banner-bottom h2 {
  /* text-transform: uppercase; */
  font-family: "Open Sans";
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 7.2px;
  line-height: 24px;
  color: #ffffff;
}
.grid {
  padding-top: 60px;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
}
.grid h3 {
  text-transform: uppercase;
  font-family: "Open Sans";
  font-size: 24px;
  font-weight: 800;
  letter-spacing: 0px;
  line-height: 24px;
  color: #ffffff;
  padding-left: 20px;
}
.border-bottom h2 {
  border-bottom: 1px solid white;
  padding-bottom: 15px;
}
.grid h4 {
  text-transform: uppercase;
  font-family: "Open Sans";
  font-size: 60px;
  font-weight: 300;
  letter-spacing: 0px;
  line-height: 24px;
  color: #ffffff;
}
.flex {
  display: inline-flex;
}
.flex .left {
  margin-right: 20px;
}
.logo-im {
  max-width: 160px;
  max-height: 63px;
}
@media only screen and (min-width: 601px) and (max-width: 1100px) {
  a {
    color: black;
  }
  .grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }

  .banner-bottom h2 {
    text-transform: uppercase;

    font-size: 16px;

    letter-spacing: 6.4px;
    line-height: 24px;
  }
  .banner-bottom {
    padding-top: 54px;
    padding-bottom: 50px;
    padding-left: 20px;
    padding-right: 20px;
  }
  .right-image-social {
    display: none;
  }

  .left-heading img {
    max-width: 150px;
    max-height: 60px;
    margin-left: -15px;
  }
  .col-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-5 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .right-image img {
    margin-top: 100px;
    padding-top: 0px;
    max-width: 100%;
    max-height: 325px;
    display: flex;
    align-items: flex-end;
  }
  .left-heading h2 {
    font-size: 30px;

    letter-spacing: -1.5px;
    line-height: 35px;
  }
  .left-heading h2 span {
    font-size: 30px;

    letter-spacing: -1.5px;
    line-height: 35px;
  }
  .left-heading h5 {
    padding-top: 15px;
    padding-bottom: 25px;
  }
  .btn {
    text-align: center;
    max-width: 80%;
    height: 50px;
    border-radius: 0;
    margin-bottom: 15px;
    width: 100%;
  }
  /* .position input[type="radio"]:checked+label { font-weight: bold;
  border: 3px solid #FFC600;
  } */

  .left-heading {
    padding-top: 55px;
    display: flex;
    padding-left: 12px;
    padding-right: 12px;

    flex-direction: column;
    justify-content: flex-end;
    max-height: 750px;
  }
}
@media only screen and (max-width: 600px) {
  .flexing {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 8px 10px;
  }
  .left-heading span::before {
    padding-left: 10px;
  }
  .grid {
    padding-top: 20px;
    display: grid;
    grid-template-columns: repeat(1, 1fr);
  }
  .grid h4 {
    font-size: 20px;
    font-weight: 700;
  }
  .banner-bottom h2 {
    text-transform: uppercase;

    font-size: 16px;

    letter-spacing: 6.4px;
    line-height: 24px;
  }
  .banner-bottom {
    padding-top: 54px;
    padding-bottom: 50px;
    padding-left: 20px;
    padding-right: 20px;
  }
  .right-image-social {
    display: none;
  }
  .row {
    display: flex;
    flex-direction: column;
  }
  .left-heading img {
    max-width: 150px;
    max-height: 60px;
    margin-left: 0px;
  }
  .col-6 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .col-5 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .right-image img {
    padding-top: 0px;
    max-width: 100%;
    max-height: 325px;
    display: flex;
    align-items: flex-end;
  }
  .left-heading h2 {
    font-size: 30px;

    letter-spacing: -1.5px;
    line-height: 35px;
  }
  .left-heading h2 span {
    font-size: 30px;

    letter-spacing: -1.5px;
    line-height: 35px;
  }
  .left-heading h5 {
    padding-top: 15px;
    padding-bottom: 25px;
  }
  .left-heading h5 {
    font-size: 18px;

    letter-spacing: 0px;
    line-height: 24px;

    padding-top: 10px;
    padding-bottom: 5px;
  }
  .btn {
    background-color: #035bf4;
    text-align: center;
    max-width: 100%;
    height: 60px;
    border-radius: 0;
    margin-bottom: 15px;
    width: 100%;
    border-radius: 25px;
  }

  .left-heading {
    padding-top: 20px;
    display: flex;
    padding-left: 12px;
    padding-right: 12px;

    flex-direction: column;
    justify-content: flex-end;
    max-height: 750px;
  }
  /* .left-heading{
    width: 100%;
    order: 1;
  } */
}

@media only screen and (max-width: 372px) {
  .left-heading h2 {
    font-size: 24px;

    letter-spacing: -1.5px;
    line-height: 30px;
  }
  .left-heading h2 span {
    font-size: 24px;

    letter-spacing: -1.5px;
    line-height: 30px;
  }
  .left-heading h5 {
    font-size: 14px;

    letter-spacing: 0px;
    line-height: 24px;

    padding-top: 10px;
    padding-bottom: 5px;
  }

  .left-heading {
    padding-top: 5px;
  }
}
</style>
